var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerEventsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_2113)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M8.12891 3.04688H5.08203C2.83836 3.04688 1.01953 4.86571 1.01953 7.10938V9.14062H4.06641V7.10938C4.06641 4.86571 5.88529 3.04688 8.12891 3.04688Z",
    fill: "url(#paint0_linear_655_2113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1836 12.7969L19.1992 13.8125M19.1992 13.8125L20.2148 12.7969M19.1992 13.8125V23.9689M18.1836 24.9844L19.1992 23.9688L20.2148 24.9844M13.4141 16.7233L14.8015 16.3516M14.8015 16.3516L14.4297 14.9642M14.8015 16.3516L23.5971 21.4297M23.9688 22.817L23.597 21.4297L24.9844 21.058M14.4297 22.817L14.8015 21.4297M14.8015 21.4297L13.4141 21.058M14.8015 21.4297L23.5971 16.3515M24.9844 16.7233L23.597 16.3516L23.9688 14.9642",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10937 1.01562V5.07812M17.2656 1.01562V5.07812M10.1562 23.3594H5.07812C2.83451 23.3594 1.01562 21.5405 1.01562 19.2969V7.10938C1.01562 4.86561 2.83451 3.04688 5.07812 3.04688H19.2969C21.5405 3.04688 23.3594 4.86561 23.3594 7.10938V9.14062M23.3594 9.14062H1.01562M23.3594 9.14062V11.1719",
    stroke: "url(#paint1_linear_655_2113)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 13.5,
    r: 1.5,
    fill: "url(#paint2_linear_655_2113)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_2113",
    x1: 1.01953,
    y1: 3.04687,
    x2: 5.73966,
    y2: 10.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_655_2113",
    x1: 1.41537,
    y1: -1.49672,
    x2: 27.2521,
    y2: 22.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_655_2113",
    x1: 4,
    y1: 12,
    x2: 6.46263,
    y2: 15.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_2113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerEventsWhite);
export default __webpack_public_path__ + "static/media/customer_eventsWhite.758c00be584d550ff9655b6b7ea46d7f.svg";
export { ForwardRef as ReactComponent };